<mat-panel-title class="exp-panel-title">
  <div class="header-left">
    <a
      [routerLink]="[
        '/app/main',
        {
          outlets: {
            navigation: ['event', data?.event?.id || data?.eventId],
            content: ['event-markets', data?.event?.id || data?.eventId],
          },
        },
      ]"
      class="event">
      {{ data?.event?.name || data?.eventName }}
    </a>
    @if (data?.marketName) {
      <span>&nbsp;-&nbsp;</span>
    }
    <a class="market" [routerLink]="getMarketRoute(data)">{{ data?.marketName }} </a>
  </div>
  <div class="header-right">
    <mat-icon (click)="$event.stopPropagation()" [routerLink]="getMarketRoute(data)" matTooltip="View full market">fullscreen</mat-icon>
    <mat-icon (click)="handleRules(data, $event)" matTooltip="Market Rules">info</mat-icon>
    @if (myMarketsService.myMarkets$ | async; as myMarkets) {
      @let marketExists = myMarkets.has(data?.marketId);
      @let marketAddedManually = myMarkets.get(data?.marketId)?.source === "manual";
      @if (marketExists && marketAddedManually) {
        <mat-icon matTooltip="Remove from My Market" (click)="removeFromMyMarkets($event)" color="warn">cancel</mat-icon>
      }
    }
  </div>
</mat-panel-title>
